import React, { useEffect, useRef } from 'react';
import { useSimulationStore } from '@/store/simulationStore';
import type { DeviceId } from '@/core/types';

export const AnalogStatusMonitor: React.FC<{ deviceId: DeviceId }> = ({ deviceId }) => {
  const rawRef = useRef<HTMLSpanElement>(null);
  const engRef = useRef<HTMLSpanElement>(null);
  const statusRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    let animationFrameId: number;
    
    const update = () => {
      const state = useSimulationStore.getState();
      const device = state.engine.process.getDevice(deviceId);
      
      if (device) {
        const dState = device.getState();
        if (typeof dState['signalStatus'] === 'string') {
          if (statusRef.current) {
            statusRef.current.textContent = dState['signalStatus'];
            statusRef.current.style.color = dState['signalStatus'] === 'NORMAL' ? 'var(--color-success)' : 'var(--color-danger)';
          }
          if (rawRef.current) {
            if (device.type === 'level-sensor') {
              rawRef.current.textContent = typeof dState['outputValue'] === 'number' ? dState['outputValue'].toString() : '-';
            } else if (device.type === 'pump' || device.type === 'valve') {
              const addr = device.props['address'] as string;
              if (addr && (addr.includes('W') || addr.includes('D'))) {
                rawRef.current.textContent = String((device as unknown as { readPlcAnalogOutput?: (host: unknown, address: string) => number }).readPlcAnalogOutput?.(state.engine.host, 'address') ?? '-');
              } else {
                rawRef.current.textContent = '-';
              }
            }
          }
          if (engRef.current) {
            if (device.type === 'level-sensor') {
              engRef.current.textContent = typeof dState['scaledValue'] === 'number' ? dState['scaledValue'].toFixed(2) : '-';
            } else if (device.type === 'pump' || device.type === 'valve') {
              engRef.current.textContent = typeof dState['actualFlow'] === 'number' ? dState['actualFlow'].toFixed(2) : '-';
            }
          }
        }
      }
      
      animationFrameId = requestAnimationFrame(update);
    };
    
    update();
    return () => cancelAnimationFrame(animationFrameId);
  }, [deviceId]);

  return (
    <div style={{ marginTop: '20px', padding: '10px', backgroundColor: 'var(--color-surface-elevated)', borderRadius: '8px' }}>
      <h3 style={{ fontSize: '12px', margin: '0 0 10px 0', color: 'var(--color-text-secondary)' }}>Analog Sinyal Durumu</h3>
      <div style={{ fontSize: '13px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>Durum:</span>
          <span ref={statusRef} style={{ fontWeight: 'bold' }}>-</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>Ham Değer (Raw):</span>
          <span ref={rawRef}>-</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>Mühendislik Değeri:</span>
          <span ref={engRef}>-</span>
        </div>
      </div>
    </div>
  );
};
